import { styled } from '@mui/material';
import { ReactNode } from 'react';

export interface LayoutProps {
  title: string;
  headerAction?: ReactNode;
  children: ReactNode;
}

export function Layout({ title, headerAction, children }: LayoutProps) {
  return (
    <Root>
      <Title>{title}</Title>
      {headerAction && <HeaderAction>{headerAction}</HeaderAction>}
      <Content>{children}</Content>
    </Root>
  );
}

export interface Layout2Props {
  title: string;
  secondaryTitle: ReactNode;
  headerAction?: ReactNode;
  children: ReactNode;
  backAction: ReactNode;
}

export function Layout2({
  backAction,
  title,
  secondaryTitle,
  headerAction,
  children,
}: Layout2Props) {
  return (
    <Root2>
      {backAction && <BackAction>{backAction}</BackAction>}
      <Title>{title}</Title>
      <SecondaryTitle>{secondaryTitle}</SecondaryTitle>
      {headerAction && <HeaderAction>{headerAction}</HeaderAction>}
      <Content>{children}</Content>
    </Root2>
  );
}

const Root = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'grid',
  grid: `"title header-action" 72px
         "content content" 1fr
         / 1fr auto`,
  padding: 16,
  paddingTop: 0,
  background: theme.palette.primary.light,
}));

const Root2 = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'grid',
  grid: `"back-action title header-action" 72px
         "title2 title2 title2" 72px
         "content content content" 1fr
         / 40px 1fr auto`,
  padding: 16,
  background: theme.palette.primary.light,
}));

const Title = styled('h3')(({ theme }) => ({
  gridArea: 'title',
  alignSelf: 'center',
  marginLeft: 16,
  ...theme.typography.h3,
}));

const SecondaryTitle = styled('h5')(({ theme }) => ({
  gridArea: 'title2',
  alignSelf: 'start',
  marginLeft: 57,
  ...theme.typography.h5,
  fontWeight: '700',
}));

const HeaderAction = styled('div')({
  gridArea: 'header-action',
  alignSelf: 'center',
  marginRight: 16,
});

const BackAction = styled('div')({
  gridArea: 'back-action',
  alignSelf: 'center',
  marginRight: 16,
});

const Content = styled('div')(({ theme }) => ({
  width: '100%',
  minHeight: 0,
  gridArea: 'content',
  placeSelf: 'stretch center',
  padding: '0 16px',
  backgroundColor: theme.palette.background.default,
}));
